import { apiClient } from "../api/apiClient";
import { StoneType, CreateStoneTypeRequest, UpdateStoneTypeRequest } from "../interfaces/StoneType";

type ResponseDto<T> = {
  loggingHistoryID?: number;
  statusCode: number;
  isSuccess: boolean;
  message: string;
  errors?: string[];
  data?: T;
  dataList?: T[];
};

export const stoneTypeService = {
  getAll: async (): Promise<ResponseDto<StoneType>> => {
    const response = await apiClient.get<ResponseDto<StoneType>>("/StoneTypes/GetActiveAll");
    return response.data;
  },
  getById: async (stoneTypeID: number): Promise<ResponseDto<StoneType>> => {
    const response = await apiClient.get<ResponseDto<StoneType>>(`/StoneTypes/GetById/${stoneTypeID}`);
    return response.data;
  },
  create: async (payload: CreateStoneTypeRequest): Promise<ResponseDto<StoneType>> => {
    const response = await apiClient.post<ResponseDto<StoneType>>("/StoneTypes/Create", payload);
    return response.data;
  },
  update: async (payload: UpdateStoneTypeRequest): Promise<ResponseDto<StoneType>> => {
    const response = await apiClient.put<ResponseDto<StoneType>>(`/StoneTypes/Update/${payload.stoneTypeID}`, payload);
    return response.data;
  },
  delete: async (stoneTypeID: number): Promise<ResponseDto<any>> => {
    const response = await apiClient.delete<ResponseDto<any>>(`/StoneTypes/Delete/${stoneTypeID}`);
    return response.data;
  },
};
